import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Notes from 'midi/Notes.js';

let OCTAVES = 7;
const NoteDisplayComponent = ({effect}) => { 
    let notes  = effect.notes;
    let keys = Object.keys(notes);
    let _notes = {};

    for (let k of keys) {
        _notes[Notes.fromTranspose(parseFloat(k)).note] = parseFloat(parseFloat(k)+32);
    }

    let inner = [];
    return (
        <div className="note-display">
        {Notes.NOTES.map(
            x => {
                let className = "note";
                if (x.isBlackNote()) className += " black";
                if (_notes[x.note]) className += " playing";
                return (
                    <div style={{filter: "hue-rotate(" + 2*_notes[x.note] + "deg)"}} className={className}/>
                );
            })}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      step: props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoteDisplayComponent);
